import ConfigPanelMixinMenu from '../components_mixins/ConfigPanelMixinMenu';
import ConfigPanelMixinPanels from '../components_mixins/ConfigPanelMixinPanels';

export const ConfigPanelMixin = {
    data() {
        return {
            showConfigPanel: false,
            showConfigUserPanel: false,
            showConfigConfigPanel: false,
            showConfigLocationPanel: false,
            showConfigSpacePanel: false,
            showConfigInfoPanel: false,
        };
    },
    provide() {
        return { parent: this };
    },
    components: { ConfigPanelMixinMenu, ConfigPanelMixinPanels },
    methods: {
        openConfigPanel() {
            this.showConfigPanel = true;
            this.showConfigUserPanel = false;
            this.showConfigConfigPanel = false;
            this.showConfigLocationPanel = false;
            this.showConfigSpacePanel = false;
            this.showConfigInfoPanel = false;
        },
        openConfigMenu(menu) {
            switch (menu) {
                case 'user':
                    this.showConfigUserPanel = true;
                    break;
                case 'locations':
                    this.showConfigLocationPanel = true;
                    break;
                case 'space':
                    this.showConfigSpacePanel = true;
                    break;
                case 'configuration':
                    this.showConfigConfigPanel = true;
                    break;
                case 'info':
                    this.showConfigInfoPanel = true;
                    break;
            }
        },
    },
};
